import styled from '@emotion/styled/macro';
import { Text } from '@chakra-ui/react';
import { format } from 'date-fns';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from 'store';
import BlockContent from '@sanity/block-content-to-react';
import { PolicyPage } from 'components';
import { isCorporateThemeSelector } from 'modules/app/appSlice';

const StyledText = styled(Text)`
  line-height: 160%;
  margin-bottom: 6px;
`;

const PartnerTerms: FC = () => {
  const { t } = useTranslation('settings');
  const { partnerTerms, partnerUpdateTime } = useSelector((state: RootState) => state.terms);
  const isCorporateTheme = useSelector(isCorporateThemeSelector);

  return (
    <>
      {partnerUpdateTime && (
        <StyledText fontSize={isCorporateTheme ? 'xs' : 'mdMax'} fontWeight={isCorporateTheme ? 400 : 500} color="secondary.500">
          {t('terms.updated')}: {format(new Date(partnerUpdateTime), 'PP')}
        </StyledText>
      )}
      <PolicyPage showButton>
        <BlockContent blocks={partnerTerms} />
      </PolicyPage>
    </>
  );
};

export default PartnerTerms;
